

import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import ConsultantLayout from "../commonlayouts/consultantlayout"; 
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Link, useNavigate } from 'react-router-dom';
import SampleTemplate from "../assets/documents/samplecandidatelist_madhan.xlsx";
import Swal from "sweetalert2";
import { AddBenchCandidatesProfile_BulkImport, GetJobRoles } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";


const Addbulkdata = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userGuid, setUserGuid] = useState("");
    const [jobRoles,SetJobRoles]=useState([{}]);
    const {selectedCountry}=useCountry();
   const navigate= useNavigate();
    useEffect(() => {
      FetchJobroles();
      const storedUserGuid = localStorage.getItem("guid");
      if (storedUserGuid) {
        setUserGuid(storedUserGuid);
      }
    }, [selectedCountry]);
  
    const handleFileChange = (e) => {
      setFile(e.target.files[0]);
    };
  
    let Guid="";

    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")    
    const roleID = localStorage.getItem("roleID")
  const token = localStorage.getItem('jwtToken');  
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }
    
    const FetchJobroles=()=>
      {
        const GetapiUrl= `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`; 
        const fetchJSON = async () => {
          const response = await fetch(GetapiUrl);
          let json = await response.json();
          SetJobRoles(json);
        }
        fetchJSON();
    }

    const getJobRole = (id) => {
      const trimmedId = id?.trim().toLowerCase();
      const role = jobRoles.find(role => role.jobRole?.trim().toLowerCase()==trimmedId )
      return role ? role.jobRoleId : 'Unknown';
  };
  
  
    const handleImport = async () => {
      if (!file) {
        setError("Please select a file.");
        return;
      }
  
      setLoading(true);
      setError(null);
  
      try {
        // Read the Excel file
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        
        function excelDateToJSDate(excelDate) {
          if (!excelDate) {
            return "2000-01-01"; // Default date when DOB is not available
        }
          // Convert Excel date serial number to JavaScript Date object
          const date = new Date((excelDate - (25567 + 2)) * 86400 * 1000);
          // Format the date as DD-MM-YYYY
          const day = ("0" + date.getDate()).slice(-2);
          const month = ("0" + (date.getMonth() + 1)).slice(-2);
          const year = date.getFullYear();
          return `${year}-${month}-${day}`.toString();
      }
        // Format the JSON data
        const formattedData = jsonData.map((item) => ({
          userGuid: Guid,
          fullName: item.fullName,
          email: item.email || 'N/A',
          mobileNumber: item.mobileNumber?.toString(),
          dob: item.dob ? excelDateToJSDate(item.dob) : null, // Check before conversion
          gender: 'Male',
          address: item.address,
          jobRole:5,
          maritalStatus: 'married',
          technicalSkill: item.technicalSkill,
          experience: item.experience,
          preferLocation: item.Country,
          workMode: 'Hybrid',
          profileSummery: item.profileSummery,
          billRate: item.billRate,
          payRate: item.payRate,
          workAuthorizationandValidity: item.workAuthorizationandValidity ,
          employerName: item.employerName ,
          ssn: item.ssn?.toString(),
          passportNo: item.passportNo,
          tworefrencesfromrecentproject: item.tworefrencesfromrecentproject ,
          linkedInUrl: item.linkedInUrl,
          certifications: item.certifications,
          createdBy: email,
          countryID:selectedCountry
    }));
  
        const response = await axios.post(
         AddBenchCandidatesProfile_BulkImport.APIURL,
          formattedData,
          {
            headers: {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${token}` 
            },
          }
        );
    
    if (response.data.candidates && Array.isArray(response.data.candidates)) {
      const messages = response.data.candidates?.map((candidate) => {
        const { email, statusMessage } = candidate;
  
       if (email === "N/A") {
      return `❌ <strong>Email doesn’t exist</strong> for that candidate.`;
    } 
      else if (statusMessage === 'Inserted') {
          return `✅ <strong>${email}</strong> added successfully.`;
        } else if (statusMessage === 'Duplicate or Already Exists') {
          return `⚠️ <strong>${email}</strong> already exists.`;
        } else {
          return `ℹ️ <strong>${email}</strong>: ${statusMessage}`;
        }
      });
  
      Swal.fire({
        icon: 'info',
        title: 'Candidate Upload Summary',
        html: messages.join('<br>'),
        showConfirmButton: true,
      });
                navigate("/Employer/GetCandidatesByEmployerUserID")

    } else {
      Swal.fire({
        icon: 'error',
        title: 'Unexpected response format.',
        text: 'Please check the server response.',
        showConfirmButton: true,
      });
    }
        setLoading(false);
      } catch (error) {
        console.error("Import error:", error);
        setError("Error occurred during import. Please try again.");
        setLoading(false);
      }
    };
  
    return (
      <ConsultantLayout>
        <section>
          <div className="container-fluid mt-4 pb-5">
            <div className="row">
              <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/GetCandidatesByEmployerUserID">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Import Candidates</h2>
</div>
              </div>
              <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3'>
            <div style={{ float: "right" }}>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Sample Excel</Tooltip>)}>

              <a href={SampleTemplate} download="SampleFile.xlsx">  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-download"></i></button> </a>
                 </OverlayTrigger>
             
            </div>
          </div>
            </div>
            <hr />
            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
              <div className="">
                <div className="" style={{ background: "#f8f8f8"}}>
                  <div className="d-flex">
                      <div >
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Upload Excel File</Tooltip>)}>

                    <input type="file"  className=" form-control"onChange={handleFileChange} />
                   </OverlayTrigger> </div>
                    {error && <div className="invalid-feedback">{error}</div>}
                   
                    <button style={{marginLeft:15 }} onClick={handleImport}  className="btn btn-primary ">
                    {loading ? "Importing..." : "Import"}
                        </button>
                    
                  </div>
                 
  </div>
                </div>
  
              </div>
            </div>
          </div>
        </section>
      </ConsultantLayout>
    );
  };
  
  export default Addbulkdata;